import { c as _c } from "react/compiler-runtime";
import type { CollectionView } from "./useCollectionsListing";

/**
 * The shape of the results before they arrive — the deck card or the ledger
 * row drawn in shimmer, so the page does not jump when they land. Used for
 * the first load and whenever a tab, sort, filter or page swaps the set.
 */
export default function CollectionsSkeleton(t0) {
  const $ = _c(12);
  const {
    view,
    count,
    label
  } = t0;
  let t1;
  if ($[0] !== count) {
    t1 = Array.from({
      length: count
    }, _temp);
    $[0] = count;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const slots = t1;
  if (view === "table") {
    let t2;
    if ($[2] !== slots) {
      t2 = slots.map(_temp2);
      $[2] = slots;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== label || $[5] !== t2) {
      t3 = <div className="v2-clx-ledger" role="status" aria-label={label}>{t2}</div>;
      $[4] = label;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t2;
  if ($[7] !== slots) {
    t2 = slots.map(_temp3);
    $[7] = slots;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== label || $[10] !== t2) {
    t3 = <div className="v2-clx-grid" role="status" aria-label={label}>{t2}</div>;
    $[9] = label;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
function _temp3(i_1) {
  return <span className="v2-clx-skel-card" key={i_1}><span className="v2-clx-skeleton v2-clx-skel-plate" /><span className="v2-clx-skeleton v2-clx-skel-line" /><span className="v2-clx-skeleton v2-clx-skel-line v2-clx-skel-line--short" /></span>;
}
function _temp2(i_0) {
  return <span className="v2-clx-skel-row" key={i_0}><span className="v2-clx-skeleton v2-clx-skel-no" /><span className="v2-clx-skeleton v2-clx-skel-logo" /><span className="v2-clx-skel-lines"><span className="v2-clx-skeleton v2-clx-skel-line" /><span className="v2-clx-skeleton v2-clx-skel-line v2-clx-skel-line--short" /></span><span className="v2-clx-skeleton v2-clx-skel-pill" /></span>;
}
function _temp(_, i) {
  return i;
}